import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.736 17.755a.9.9 0 0 1-1.272 0L7.8 9.091v6.828a.9.9 0 0 1-1.8 0v-9a.9.9 0 0 1 .9-.9h9a.9.9 0 1 1 0 1.8H9.073l8.663 8.663a.9.9 0 0 1 0 1.273",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }